export default __webpack_public_path__ + "static/media/map.3d469ac8.png";